import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../hoc/formikComponents/FormikControl.js'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import * as BiIcons from 'react-icons/bi';
import * as AiIcons from 'react-icons/ai';
import { useQueryClient } from 'react-query'

function DepartmentMaster() {
    const queryClient = useQueryClient();
    const [initialValues, setInitialValues] = useState(
        {
            id: "",
            departmentName: "",
        })
    const validationSchema = Yup.object({
        departmentName: Yup.string().required("required !!").matches(/^[0-9a-zA-Z]+$/, "Special Characters are not allowed")
    })
    const onSubmit = (values, { setSubmitting, resetForm }) => {
        resetForm({ id: "", departmentName: "" })
        if (values.id === "") {
            mutation.mutate(values)
        } else {
            mutationEdit.mutate(values)
        }
    }
    const { data: departmentMasterList, isLoading } = useQuery('listdepartments',
        () => Fetcher('get', '/api/departmentMaster/get/listdeparmentmaster', {}))
    const mutation = useMutation((params) => Fetcher('post', '/api/departmentMaster/post/data', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Department Name Added')
                queryClient.invalidateQueries('listdepartments');
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    }

    )
    const mutationEdit = useMutation((params) => Fetcher('patch', '/api/departmentMaster/patch/deparmentmaster', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Department Edited')
                queryClient.invalidateQueries('listdepartments');
                setInitialValues({ id: "", departmentName: "" })
            } else {
                var msg = 'Department - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    }

    )
    const mutatationDelete = useMutation((params) => Fetcher('delete', '/api/departmentMaster/delete/deparmentmaster', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                if (data.data.errorCode === 0) {
                    ToastInstance('Success', 'Department Deleted')
                    queryClient.invalidateQueries('listdepartments');
                } else {
                    var msg = 'departmentName - ' + data.data.errorMsg;
                    ToastInstance('Error', msg)
                }

            }
        }
    }

    )
    function editData(item) {
        setInitialValues({
            id: item._id,
            departmentName: item.departmentName
        })
    }
    function deleteData(deleteId) {
        var jsonRequest = { id: deleteId }
        mutatationDelete.mutate(jsonRequest)
    }
    if (isLoading) return <h1>Loading</h1>
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                //validationSchema={validationSchema}
                onSubmit={onSubmit}

            >{
                    formik =>
                        <Form>
                            <div className="content-wrapper">
                                <section className="content">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="card-body" style={{minHeight:"470px"}}>
                                                    <div className="row htmlpage">
                                                        <div className="col-sm-12">
                                                           
                                                                <div className="row mt-1">
                                                                <div className="col-sm-11" style={{marginLeft:"1%"}}>
                                                                    <FormikControl control='input' type='text' name='departmentName' label="Department Name *" placeholder="Department Name"/>
                                                                </div>
                                                            </div>
                                                            <br/>
                                                            <div className="row">
                                                                <div className="col-lg-10"></div>
                                                                <div className="col-lg-2">
                                                                <button type="submit" className="btn btn-primary" disabled={!formik.isValid}>Submit</button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <br />
                                                    <div className="row">
                                                        <div className="col-lg-12 col-lg-offset-1">
                                                        <div class="card-body table-responsive">
                                                            <table className="table table-bordered" >
                                                                <thead className="table-primary">
                                                                    <tr>
                                                                        <th scope="col" className="text-center" style={{ "width": "100px" }}>#</th>
                                                                        <th scope="col" className="text-center">Department Name</th>
                                                                        <th scope="col" className="text-center" style={{ "width": "120px" }}>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody >
                                                                    {
                                                                        departmentMasterList.data.response && departmentMasterList.data.response.length > 0 && departmentMasterList.data.response.map((item, index) => {
                                                                            return (
                                                                                <tr key={index}>
                                                                                    <td className="text-center">{index + 1}.</td>
                                                                                    <td>{item.departmentName}</td>
                                                                                    <td className="text-center">
                                                                                        <span style={{ "marginRight": "6%", "cursor": "pointer" }} onClick={() => editData(item)}><BiIcons.BiEdit /></span>
                                                                                        <span style={{ "marginLeft": "6%", "cursor": "pointer" }} onClick={() => deleteData(item._id)}><AiIcons.AiOutlineDelete /></span>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                           
                        </Form>
                }
            </Formik>
        </div>
    )
}

export default DepartmentMaster
